import * as Yup from 'yup';

export const contactFormSchema = Yup.object().shape({
    contactsFirstName: Yup.string().required('First name is required'),
    contactsLastName: Yup.string().required('Last name is required'),
    contactsWorkEmail: Yup.string().email('Must be a valid email').required('Email is required'),
    contactsSecondaryEmail: Yup.string().email('Must be a valid email'),
    contactsOfficePhone: Yup.string().matches(/^[0-9]+$/, { excludeEmptyString: true, message: 'Invalid phone number' }),
    contactsCellPhone: Yup.string().matches(/^[0-9]+$/, { excludeEmptyString: true, message: 'Invalid phone number' }),
    contactsOtherPhone: Yup.string().matches(/^[0-9]+$/, { excludeEmptyString: true, message: 'Invalid phone number' }),

    contactRole: Yup.object()
        .nullable()
        .when(
            ['ppiReportStatusIDs', 'susReportStatusIDs', 'otherReportStatusIDs'],
            {
                is: (ppi: any, sus: any, other: any) =>
                    (ppi?.length ?? 0) > 0 ||
                    (sus?.length ?? 0) > 0 ||
                    (other?.length ?? 0) > 0,

                then: (schema) => schema.required('Contact Role is required.'),

                otherwise: (schema) => schema.nullable().notRequired(),
            }
        )
});
